import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SignUpRequest, SignUpVerifyRequest } from '../models/signup.models';

@Injectable({
  providedIn: 'root',
})
export class SignupApiService {
  private baseUrl: string = environment.api.signupUrl;

  constructor(private httpClient: HttpClient) {}

  public verifyEmail(
    fullName: string,
    email: string,
  ): Observable<any> {
    const signupRequest: SignUpVerifyRequest = { email: email, fullName: fullName };

    return this.httpClient.post(
      `${this.baseUrl}/api/v1/verify-emails`,
      signupRequest,
      { observe: 'response' },
    );
  }

  public completeSignUp(
    fullName: string,
    email: string,
    orgCode: string,
    orgName: string,
    token: string | null,
    adminEmail1: string | null,
    adminEmail2: string | null,
    adminEmail3: string | null
  ): Observable<any> {
    const signupRequest: SignUpRequest = { email: email, fullName: fullName, orgCode: orgCode, orgName: orgName, token: token, adminEmail1, adminEmail2, adminEmail3 };

    return this.httpClient.post(
      `${this.baseUrl}/api/v1/signups`,
      signupRequest,
      { observe: 'response' },
    );
  }
}
